module.exports = __webpack_public_path__ + "img/lens-174-minus-05.9545553a.png";